/**
 * Build tree based on parent and primary key.
 * Primary key and parent key must have integer value.
 * Done based on references
 *
 * @param Array<any> data
 * @param String parentField
 * @param String primaryKey
 * @return Array<any>
 */
export default (data: Array<any>, parentField: string, primaryKey: string = 'id') => {
    // console.log('building tree', data);
    const tree: Array<any> = [];
    const tmp: Array<any> = [];

    // create temporary list with children
    data.forEach((value: any) => tmp.push({ ...value, children: [] }));

    tmp.forEach((value: any, index: number) => {
        value.title = value.title
        value.key = value.id
        // when there is no parentField, push to root
        if (!value[parentField]) {
            tree.push(value);
        }

        // if parentField, search for and attach as a children
        if (value[parentField]) {
            const parentValue = tmp.find((p: any) => {
                return p[primaryKey] === value[parentField];
            });

            if (parentValue) {
                parentValue.children.push(value);
            }
        }
    });

    return tree;
};



// WEBPACK FOOTER //
// ./src/helpers/tree.ts